// Starts Sentry, and does nothing else. Importing THIS file has an effect; importing
// `app-sentry.ts` does not (deferred finding df-106e22b8ff13).
//
// Why it is a module of its own rather than a call in main.ts's body: a module body runs AFTER
// its whole import graph has been evaluated. A call at the top of main.ts would therefore start
// Sentry LATER than the old import-time init did — every module-level initialiser in the app
// would run with no Sentry global handlers installed. As main.ts's FIRST import, this runs
// BEFORE the rest of the graph, which is earlier than the old arrangement rather than later.
//
// So the import in main.ts must stay first, and must stay a bare side-effect import.
// `client/package.json` declares no `sideEffects: false`, so webpack keeps it.

import { initSentry } from './app-sentry';

initSentry();
